// modules
import { createAction } from 'redux-actions'

export const setCreatedNewTask = createAction('SET_CREATED_NEW_TASK')

export const setEditableTask = createAction('SET_EDITABLE_TASK')
export const setDefaultCommentTask = createAction('SET_DEFAULT_COMMENT_TASK')

export const setPatientListTaskModal = createAction(
  'SET_PATIENT_LIST_TASK_MODAL'
)

export const setIsAddTaskModalVisible = createAction(
  'SET_IS_ADD_TASK_MODAL_VISIBLE'
)

export const setEditableTaskComments = createAction(
  'SET_EDITABLE_TASK_COMMENTS'
)

export const setHistoryItems = createAction('SET_EDITABLE_TASK_HISTORY_ITEMS')
